export function formatGatewayLabel(gatewayName, gatewayId) {
  if (gatewayName && gatewayId !== undefined && gatewayId !== null) {
    return `${gatewayName} (${gatewayId})`;
  }
  if (gatewayName) {
    return gatewayName;
  }
  if (gatewayId !== undefined && gatewayId !== null) {
    return String(gatewayId);
  }
  return null;
}

export function getPcuGatewayDisplay(pcu) {
  if (!pcu) {
    return { label: null, gatewayId: null, hasGateway: false };
  }
  const gatewayId = pcu.gatewayId !== undefined && pcu.gatewayId !== null
    ? pcu.gatewayId
    : (pcu.gateway && pcu.gateway.id !== undefined && pcu.gateway.id !== null
      ? pcu.gateway.id
      : null);
  const gatewayName = pcu.gatewayName || (pcu.gateway && pcu.gateway.name) || null;
  const label = formatGatewayLabel(gatewayName, gatewayId)
    || gatewayName
    || (gatewayId !== null ? gatewayId : null)
    || (pcu.gateway && (pcu.gateway.name || pcu.gateway.id));
  const hasGateway = (gatewayId !== undefined && gatewayId !== null)
    || gatewayName
    || (pcu.gateway && (pcu.gateway.name || pcu.gateway.id));
  return { label, gatewayId, hasGateway: !!hasGateway && !!label };
}
